import { render, staticRenderFns } from "./ShowMovies.vue?vue&type=template&id=0ec0e2c5&scoped=true"
import script from "./ShowMovies.vue?vue&type=script&lang=js"
export * from "./ShowMovies.vue?vue&type=script&lang=js"
import style0 from "./ShowMovies.vue?vue&type=style&index=0&id=0ec0e2c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec0e2c5",
  null
  
)

export default component.exports